export default "__VITE_ASSET__BfCrAVRl__"